import React from 'react';
import { FileTextIcon, ExternalLinkIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
interface Resource {
  title: string;
  description: string;
}
interface OtherReport {
  title: string;
  link: string;
}
interface ResourcesSidebarProps {
  resources: Resource[];
  otherReports: OtherReport[];
}
export function ResourcesSidebar({
  resources,
  otherReports
}: ResourcesSidebarProps) {
  const navigate = useNavigate();
  return <div className="space-y-6" data-id="element-970">
      {/* Resources Section */}
      <div className="bg-gray-50 rounded-lg p-6" data-id="element-971">
        <h3 className="text-sm font-semibold text-gray-900 mb-4" data-id="element-972">Resources</h3>
        <div className="space-y-4" data-id="element-973">
          {resources.map((resource, index) => <div key={index} className="flex gap-3" data-id="element-974">
              <FileTextIcon size={20} className="text-gray-400 flex-shrink-0 mt-0.5" data-id="element-975" />
              <div data-id="element-976">
                <h4 className="text-sm font-medium text-gray-900 mb-1" data-id="element-977">
                  {resource.title}
                </h4>
                <p className="text-sm text-gray-600" data-id="element-978">{resource.description}</p>
              </div>
            </div>)}
        </div>
      </div>

      {/* Other Reports Section */}
      <div className="bg-gray-50 rounded-lg p-6" data-id="element-979">
        <h3 className="text-sm font-semibold text-gray-900 mb-4 uppercase tracking-wide text-gray-600" data-id="element-980">
          View other payment reports
        </h3>
        <div className="space-y-2" data-id="element-981">
          {otherReports.map((report, index) => <button key={index} onClick={() => navigate('/reports')} className="flex items-center justify-between w-full text-left px-3 py-2 text-sm text-blue-600 hover:bg-blue-50 rounded-md transition-colors group" data-id="element-982">
              <span data-id="element-983">{report.title}</span>
              <ExternalLinkIcon size={14} className="text-blue-600 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-984" />
            </button>)}
        </div>
      </div>
    </div>;
}